import { Action, createReducer, on } from '@ngrx/store';
import * as authActions from '../actions/auth.actions';
import { TokenClaims } from '@scf-monorepo/interfaces';

export const authFeatureKey = 'auth';

export interface State {
    parsedToken: TokenClaims;
    isLoggedIn: boolean;
    accessToken: string;
    idToken: string;
    isExpired: boolean;
}

export const initialState: State = {
    parsedToken: null,
    isLoggedIn: null,
    accessToken: null,
    idToken: null,
    isExpired: false
};

const authReducer = createReducer(
    initialState,
    on(authActions.loginSuccess, (state, { tokenUserData, authResponse }) => ({
        ...state,
        isLoggedIn: true,
        tokenUserData: tokenUserData,
        accessToken: authResponse?.accessToken,
        idToken: authResponse?.idToken,
        isExpired: false
    })),
    on(authActions.tokenExpired, (state) => ({
        ...state,
        isExpired: true
    }))
);

export function reducer(state: State | undefined, action: Action) {
    return authReducer(state, action);
}
